import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { TokenService } from './token.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);
  const token = tokenService.token();
  const publicAuthRequest = request.url.includes('/auth/login')
    || request.url.includes('/clientes/auth/login')
    || request.url.includes('/auth/recuperar-password')
    || request.url.includes('/auth/reset-password');

  if (!token) {
    return next(request);
  }

  const authRequest = request.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });

  return next(authRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (!publicAuthRequest && error.status === 401) {
        tokenService.clear();
        router.navigate(['/login']);
      }

      return throwError(() => error);
    })
  );
};
